// extracted by mini-css-extract-plugin
module.exports = {"subtitle":"subtitle_subtitle__2_p37"};